import { Grid, IconButton } from "@biggeo/bg-ui/lab";
import { MenuOutline } from "@biggeo/bg-ui/lab/icons";

export type UnAuthedHeaderProps = {
    readonly openSidebar: () => void;
};

export const UnAuthedHeader = ({ openSidebar }: UnAuthedHeaderProps) => {
    return (
        <Grid
            container
            alignItems="center"
            flexWrap="nowrap"
            justifyContent="space-between"
            gap={2}
        >
            <IconButton
                variant="outlined"
                density="dense"
                onClick={openSidebar}
                sx={{
                    breakpoints: {
                        md: {
                            visibility: "hidden",
                        },
                    },
                }}
            >
                <MenuOutline size="xs" />
            </IconButton>
        </Grid>
    );
};
